import React, { Component } from 'react';
import './App.css';
// import Header from "./common/header";
// import Footer from "./common/footer";
import Routes from './Routes/routes';


class App extends Component {
  render() {
    return (
        <div>
          <Routes className="main" />
        </div>
      // <BrowserRouter>
        /* <Switch>
              <Route>
                <div>
                  <Route path="/" component={TestConent} exact/>
                  <Route path="/test" component={TestConent2} exact/>
                  <Route path="/withAgentId" component={WithAgentId}/>
                  <Route path="/withoutAgentId" component={WithoutAgentId}/>
                  <Route path="/withAccountNumber" component={WithAccountNumber}/>
                  <Route path="/*" component={PageNotFound} />
                </div>
              </Route>
            </Switch> */
      // </BrowserRouter>
      // <div className="App">
      //   <Header/>
      //   <Footer/>
      // </div>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js